import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { getPassiveReward } from "../../store/slices/userSlice";
import NoDataFound from "../NoDataFound";
import ReactPaginate from "react-paginate";

type Props = {};

const PassiveUniLevelReward = (props: Props) => {
  const dispatch = useDispatch<any>();
  const { passive_reward, passiveLoader } = useSelector(
    (state: any) => state.user
  );
  const [filterPassive, setFilterPassive] = useState({
    level: "",
  });
  const [isFiltered, setIsFiltered] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(11);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (event: any) => {
    setCurrentPage(event?.selected);
  };

  useEffect(() => {
    let newItems = passive_reward?.totalCount / itemsPerPage;
    setPageCount(newItems);
  }, [passive_reward]);

  const fetchUpdatedData = () => {
    const startIndex = currentPage * itemsPerPage;
    dispatch(getPassiveReward({ offset: startIndex, limit: 20 }));
  };

  useEffect(() => {
    fetchUpdatedData();
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    setPageCount(0);
  }, []);

  console.log(passive_reward);

  return (
    <div className=" main-p carousel-top bg-site-bg">
      <Container className="px-0 px-md-2">
        <div className="earning__title-card">
          <div className="earning__title-card__header mt-42">
            Passive Uni-Level Reward
          </div>
          <div className="earning__title-card__body d-flex justify-content-between align-items-center pointer">
            <div>
              {" "}
              <h2 className="dashboard__card__heading mb-1">Total Earning</h2>
              <h2 className="dashboard__card__value mb-0 text-site-primary number">
                $
                {passiveLoader ? (
                  <Spinner size="sm" />
                ) : passive_reward?.totalEarning ? (
                  passive_reward?.totalEarning?.toFixed(3)
                ) : (
                  0
                )}
              </h2>
            </div>
            <div className="text-end">
              {" "}
              <h2 className="dashboard__card__heading mb-1">Today's Earning</h2>
              <h2 className="dashboard__card__value mb-0 text-site-primary number">
                $
                {passiveLoader ? (
                  <Spinner size="sm" />
                ) : passive_reward?.todayEarning ? (
                  passive_reward?.todayEarning?.toFixed(3)
                ) : (
                  0
                )}
              </h2>
            </div>
          </div>
        </div>
        {/* <div className="card mt-2">
          <div className="card__header border-radius-top">
            <h2 className="card__body-heading mb-0 text-center">
              Downline Search
            </h2>
          </div>
          <div className="card__body border-radius-bottom">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                setIsFiltered(true);
                dispatch(
                  getPassiveReward({
                    offset: 0,
                    limit: itemsPerPage,
                    level: Number(filterPassive?.level),
                  })
                );
              }}
            >
              <Row className="align-items-end">
                <Col xs="4" md="6">
                  <Label>Compressed Level</Label>
                  <Input
                    placeholder="Select Level"
                    type="select"
                    value={filterPassive?.level}
                    onChange={(e: any) => {
                      setFilterPassive({
                        ...filterPassive,
                        level: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      Select Level
                    </option>
                    {new Array(150).fill(1)?.map((opt, idx) => (
                      <option value={idx + 1} key={idx}>
                        Level {idx + 1}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col xs="8" md="6">
                  <Button
                    disabled={!filterPassive?.level}
                    className="btn__primary-sm me-0 me-md-2"
                    type="submit"
                    style={{
                      minHeight: "38px",
                    }}
                  >
                    Search Now
                  </Button>
                  {filterPassive?.level ? (
                    <Button
                      className="btn__clear ms-3 ms-md-0"
                      onClick={() => {
                        setFilterPassive({
                          level: "",
                        });
                        setIsFiltered(false);
                        dispatch(
                          getPassiveReward({ offset: 0, limit: itemsPerPage })
                        );
                      }}
                      style={{
                        minHeight: "38px",
                      }}
                    >
                      Clear
                    </Button>
                  ) : (
                    ""
                  )}
                </Col>
                {isFiltered && (
                  <Col xs="12" className="mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <Label>Staking Reward at CL {filterPassive?.level}</Label>
                      <Label>
                        $
                        {passiveLoader ? (
                          <Spinner size="sm" />
                        ) : (
                          passive_reward?.totalBusiness?.toFixed(3) || 0
                        )}{" "}
                      </Label>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <Label>Today's Passive Uni-Level Reward</Label>
                      <Label>
                        $
                        {passiveLoader ? (
                          <Spinner size="sm" />
                        ) : (
                          passive_reward?.totalEarning?.toFixed(3) || 0
                        )}{" "}
                      </Label>
                    </div>
                  </Col>
                )}
              </Row>
            </Form>
          </div>
        </div> */}
        <Row>
          {passive_reward?.data?.length > 0 ? (
            <>
              {passive_reward?.data?.map((item: any, idx: number) => (
                <Col md="4" className="mt-2" key={idx}>
                  <div className="card h-100">
                    <div className="card__body border-radius-all">
                      {/* <div className="d-flex align-items-center justify-content-between">
                        <h2 className="earning-label mb-1">Date</h2>
                        <h2 className="card__body-label earning-value mb-1">
                          {item?.date ? item?.date : "NA"}{" "}
                        </h2>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="card__body-label earning-label mb-1">
                          Level
                        </h2>
                        <h2 className="card__body-label earning-value mb-1">
                          {/* {item?.ref || "NA"} / */}
                          L-
                          {item?.level || 0}
                        </h2>
                      </div>
                      {/* <div className="d-flex align-items-center justify-content-between">
                        <h2 className="earning-label mb-1">Compressed Level</h2>
                        <h2 className="card__body-label earning-value mb-1">
                          CL-{item?.clevel || 0}
                        </h2>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="earning-label mb-0">Total Reward</h2>
                        <h2 className="card__body-label earning-value mb-0">
                          ${item?.amount?.toFixed(3) || 0}
                        </h2>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="earning-label mb-0">Today Reward</h2>
                        <h2 className="card__body-label earning-value mb-0">
                          ${item?.todayAmount?.toFixed(3) || 0}
                        </h2>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
              {/* <ReactPaginate
                breakLabel="..."
                nextLabel={
                  <i className="fas fa-angle-right text-site-primary" />
                }
                onPageChange={handlePageClick}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                pageCount={pageCount}
                previousLabel={
                  <i className="fas fa-angle-left text-site-primary" />
                }
                containerClassName="custom-pagination"
                activeClassName="custom-pagination-active"
                previousClassName="custom-pagination-prev"
                nextClassName="custom-pagination-next"
                pageClassName="custom-pagination-li"
                disabledClassName="custom-pagination-disabled"
              /> */}
            </>
          ) : (
            <NoDataFound isLoading={passiveLoader} />
          )}
        </Row>
      </Container>
    </div>
  );
};

export default PassiveUniLevelReward;
